import { trigger, transition, style, animate, state } from '@angular/animations';
import { appConfig } from 'src/config';

const slideTime = appConfig.centralPage_slide_time;

export type SlideDirection = 'moveDown' | 'moveUp' | 'moveRight' | 'moveLeft' | 'none';

// Footerbalk van een tab-pagina: slideTop = details-/edit-knoppen, slideBottom = knoppen van de tab. Zolang de
// tab zichtbaar is (tab-page én medium-page) hoort de footerbalk bij de tab; de details-knoppen schuiven pas in
// bij details-page (tab verborgen) of edit/create. tab-page <-> medium-page schuift dus niets.
export const slideAnimation = [
    trigger('slideTop', [
        state('tab-page, medium-page', style({
            transform: 'translateY(-100%)',
        })),
        state('details-page, edit-page, create-page', style({
            transform: 'none',
        })),
        transition('tab-page => details-page, tab-page => edit-page, tab-page => create-page, medium-page => details-page, medium-page => edit-page, medium-page => create-page', [
            style({ transform: 'translateY(-100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(0)' })
            ),
        ]),
        transition('details-page => tab-page, edit-page => tab-page, create-page => tab-page, details-page => medium-page, edit-page => medium-page, create-page => medium-page', [
            style({ transform: 'translateY(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(-100%)' })
            ),
        ]),
    ]),
    trigger('slideBottom', [
        state('details-page, edit-page, create-page', style({
            transform: 'translateY(100%)',
        })),
        state('tab-page, medium-page', style({
            transform: 'none',
        })),
        transition('details-page => tab-page, edit-page => tab-page, create-page => tab-page, details-page => medium-page, edit-page => medium-page, create-page => medium-page', [
            style({ transform: 'translateY(100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(0)' })
            ),
        ]),
        transition('tab-page => details-page, tab-page => edit-page, tab-page => create-page, medium-page => details-page, medium-page => edit-page, medium-page => create-page', [
            style({ transform: 'translateY(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(100%)' })
            ),
        ]),
    ]),
    trigger('slide', [
        state('moveDown, moveUp, moveLeft, moveRight', style({
            position: 'absolute',
            inset: 0,
        })),
        transition('void => moveDown', [
            style({ transform: 'translateY(-100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(0)' })
            ),
        ]),
        transition('moveDown => void', [
            style({ transform: 'translateY(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(100%)' })
            ),
        ]),
        transition('void => moveUp', [
            style({ transform: 'translateY(100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(0)' })
            ),
        ]),
        transition('moveUp => void', [
            style({ transform: 'translateY(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateY(-100%)' })
            ),
        ]),
        transition('void => moveLeft', [
            style({ transform: 'translateX(100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateX(0)' })
            ),
        ]),
        transition('moveLeft => void', [
            style({ transform: 'translateX(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateX(-100%)' })
            ),
        ]),
        transition('void => moveRight', [
            style({ transform: 'translateX(-100%)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateX(0)' })
            ),
        ]),
        transition('moveRight => void', [
            style({ transform: 'translateX(0)' }),
            animate(
                `${slideTime} cubic-bezier(0.4, 0.0, 0.2, 1)`,
                style({ transform: 'translateX(100%)' })
            ),
        ]),
    ]),
];
